import { useQuery } from "@apollo/client";
import { useMemo } from "react";

import { GET_SPACELIFT_VCS_REPO } from "./gql";

type UseGetSpaceliftVcsRepoProps = {
  repoId: string | undefined;
};

const useGetSpaceliftVcsRepo = ({ repoId }: UseGetSpaceliftVcsRepoProps) => {
  const { data, loading, error, previousData } = useQuery(GET_SPACELIFT_VCS_REPO, {
    variables: { id: repoId || "" },
    skip: !repoId,
  });

  const repo = useMemo(() => {
    return data?.repo || previousData?.repo;
  }, [data, previousData]);

  return {
    repo,
    loading,
    error,
  };
};

export default useGetSpaceliftVcsRepo;
